<template>
	<div style="width: 1650px;">
		<Tabs type="card">
			<TabPane label="合同管理">
				<OnsiteCustomer ref="OnsiteCustomer"></OnsiteCustomer>
			</TabPane>
			<TabPane label="负责在审件">
				<LoanList ref="LoanList"></LoanList>
			</TabPane>
			<TabPane label="协助在审件">
				<HelpLoanList ref="HelpLoanList"></HelpLoanList>
			</TabPane>
		</Tabs>
	</div>

</template>

<script>
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import OnsiteCustomer from './OnsiteCustomer.vue';
	import LoanList from './LoanList.vue';
	import HelpLoanList from './HelpLoanList.vue';
	export default {
		name: "loan_management",

		components: {
			OnsiteCustomer,
			LoanList,
			HelpLoanList
		},
	}
</script>

<style>
</style>
